import React, { useEffect, useState, useContext, useMemo } from "react";
import { CircularProgress, TablePagination } from '@material-ui/core';

import { useStyles } from './styles';
import { useEnvironment, useSnackbar } from "hooks";
import { usePagination } from 'hooks/generictable/usePagination';
import { GenericTable } from 'components/migrated/generictable/';
import { usePendingReturnProductsGql } from "./graphql/pendingProductsReturn";
import { ColumnDefinitionType } from "components/migrated/generictable/interfaces";
import { IPendingReturnProduct } from "./graphql/pendingProductsReturn/interfaces";

export const PendingProductsReturn = (props: any) => {
  const { setState }= props;
  const classes = useStyles();
  const { DEBUG } = useEnvironment();
  const { Snackbar, toggleSnackbar } = useSnackbar();

  const {
    nextRows,
    initialRow,
    setTotalRows,
    handleChangePage,
    handleChangeRowsPerPage,
    nextRowsOptions,
    page,
    totalRows
  } = usePagination();

  const {
    runPendingReturnProductsGql,
    dataPendingReturnProducts,
    errorPendingReturnProducts,
    loadingPendingReturnProducts,
  } = usePendingReturnProductsGql();

  const columns: ColumnDefinitionType<IPendingReturnProduct, keyof IPendingReturnProduct | any>[] = [
    {
      key: "personId",
      header: "ID Fornecedor",
      headerAlign: 'left',
      cellAlign: 'right',
      columnWidth: 135,
    },
    {
      key: "personName",
      header: "Fornecedor",
      headerAlign: 'left',
      cellAlign: 'left',
    },
    {
      key: "productId",
      header: "ID Produto",
      headerAlign: 'left',
      cellAlign: 'right',
      columnWidth: 105,
    },
    {
      key: "productName",
      header: "Descrição",
      headerAlign: 'left',
      cellAlign: 'left',
    },
    {
      key: "volume",
      header: "Volume (m³)",
      headerAlign: 'left',
      cellAlign: 'right',
      columnWidth: 120,
    },
    {
      key: "itemQuantity",
      header: "Quantidade de Itens",
      headerAlign: 'left',
      cellAlign: 'right',
      columnWidth: 175,
    },
  ];

  useEffect(() => {
    if (errorPendingReturnProducts) {
      if (DEBUG === "TRUE") {
        const msg = errorPendingReturnProducts;
        console.log(`Erro ao carregar dados! Error:(message: ${msg} )`);
      } else {
        toggleSnackbar({
          message:
            "Ocorreu um problema ao carregar informações. Por favor, informe ao suporte.",
          type: "error",
        });
      }
    }
  }, [errorPendingReturnProducts]);

  useEffect(() => {
    runPendingReturnProductsGql({
      variables: {
        personId: props.state.fornecedor,
        initialRow: initialRow,
        nextRows: nextRows
      }
    });
    setState({isLoading: false})
  }, [props.state.fornecedor, initialRow, nextRows]);

  useEffect(() => {
    handleChangePage(null, 0);
  }, [props.state.fornecedor]);

  useEffect(() => {
    if (dataPendingReturnProducts && dataPendingReturnProducts.length > 0) {
      setTotalRows(dataPendingReturnProducts[0].totalRows);
    } else {
      setTotalRows(0);
    }
  }, [dataPendingReturnProducts]);

  return (
    <>
      <Snackbar />
      <div className={classes.container}>
        {loadingPendingReturnProducts && (
          <div className={classes.loader}>
            <CircularProgress />
          </div>
        )}

        {!loadingPendingReturnProducts &&
          dataPendingReturnProducts.length > 0 && (
            <>
              <GenericTable
                columns={columns}
                data={dataPendingReturnProducts}
              />
              <TablePagination
                component="div"
                count={totalRows}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={nextRows}
                onRowsPerPageChange={handleChangeRowsPerPage}
                rowsPerPageOptions={nextRowsOptions}
                labelRowsPerPage="Registros por página"
                labelDisplayedRows={({ from, to, count }) => `Mostrando ${from}-${to} de ${count}`}
              />
            </>
        )}

        {!loadingPendingReturnProducts && (!dataPendingReturnProducts || dataPendingReturnProducts.length === 0) && (
          <div style={{ textAlign: 'center'}}>
            {"Nenhum registro encontrado!"}
          </div>
          )
        }
      </div>
    </>
  );
};
